import {Component, Input} from '@angular/core';
import {NavItem} from '../../../../models/nav-item.model';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.less']
})
export class SidebarComponent {
    @Input() items: NavItem[] = [];
}
